<template lang="html">
  <b-dropdown position="is-bottom-left" v-model="currentLanguage">
    <a class="navbar-item" slot="trigger">
      <component :is="currentFlag" height="32" width="20"/>
    </a>

    <b-dropdown-item
      v-for="language in languages"
      :key="language.code"
      :value="language.code"
      @click="changeLanguage(language.code)"
    >
      <span class="icon">
        <component :is="language.flag" height="32" width="20"/>
      </span> {{ language.name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import flags from './flags'

export default {
  props: {
    current: {type: String, default: window.__INIT_DATA.lang},
    items: {type: Array,
      default: () => {
        if(window.__INIT_DATA.recipe) return window.__INIT_DATA.recipe.languages
        if(window.__INIT_DATA.category) return window.__INIT_DATA.category.languages
        if(window.__INIT_DATA.menu) return window.__INIT_DATA.menu.languages
        return []
      }}
  },

  components: flags,

  data(){
    return {
      currentLanguage: this.current
    }
  },

  computed: {
    currentFlag(){
      return `${this.currentLanguage.replace('_', '-')}-flag`
    },

    languages(){
      return this.items
      .map(k => {
        return {
          code: k,
          name: this.$t(k),
          flag: `${k.replace('_', '-')}-flag`
        }
      })
    }
  },

  methods: {
    changeLanguage(code){
      if(this.$root.availableLanguages.indexOf(code) !== -1){
        const currentPath = window.location.pathname

        const R = new RegExp(`^(${this.languages.map(l => {
          return `\\/${l.code}\\/`
        }).join('|')}|\\/)(.+)$`)
        window.location = currentPath.replace(R, `/${code}/$2`)
      }else{
        window.location = `/${code}`
      }
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "de_at": "Österreichisch",
    "de_de": "Deutsch",
    "en": "English",
    "hu": "magyar",
    "cs": "český",
    "fr": "français"
  },
  "cs": {
    "de_at": "Österreichisch",
    "de_de": "Deutsch",
    "en": "English",
    "hu": "magyar",
    "cs": "český",
    "fr": "français"
  },
  "hu": {
    "de_at": "Österreichisch",
    "de_de": "Deutsch",
    "en": "English",
    "hu": "magyar",
    "cs": "český",
    "fr": "français"
  },
  "fr": {
    "de_at": "Österreichisch",
    "de_de": "Deutsch",
    "en": "English",
    "hu": "magyar",
    "cs": "český",
    "fr": "français"
  }
}
</i18n>

<style lang="scss" scoped>
  .icon{
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelect.vue